import Selectable, {
  SelectableType,
} from '@ancon/wildcat-ui/web/orderweb/Selectable'
import '@ancon/wildcat-ui/web/orderweb/Selectable/Selectable.css'

export { SelectableType }

export default Selectable
